import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckGrey = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1024 1024",
	fill: "none",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M341.34 722.495l-199.111-199.113c-22.187-22.187-57.458-22.187-79.644 0s-22.187 57.458 0 79.644l238.364 238.366c22.187 22.187 58.027 22.187 80.213 0l603.021-602.455c22.187-22.187 22.187-57.458 0-79.645s-57.458-22.187-79.644 0l-563.199 563.202z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgCheckGrey);
export default ForwardRef;
